import React from 'react';
import { useTranslation } from 'react-i18next';

import { makeStyles } from 'tss-react/mui';
import {
  Box,
  Button,
  ContentTemplate,
  KeyValue,
  Link,
  SectionHeader,
  TitleHeader,
  Typography,
} from 'web-library';
import { useHistory, useParams } from 'react-router-dom';
import { useGetGroupExamRegistrationReceiptDetails } from '../../../api-refactored/group-exam-registration/useGetGroupExamRegistrationReceiptDetails';
import RouteKey from '../../../routes/key';
import { stringToLongDateAndShortTime } from '../../../utils/DateUtils';
import { ExamPaymentModeKey } from '../../../api-refactored/group-exam-registration/usePostReviewGroupExamRegistration';
import { useWOGAA } from '../../../hooks/wogaa';
import {typeTheme} from "web-library/theme/helper/tssHelper"

const useStyles = makeStyles()((theme) =>
({
  viewSummaryLink: {
     ...typeTheme(theme, 'buttonLarge'),
    marginLeft: theme.spacing(2),
  },
  paymentLinkMessage: {
    marginBottom: theme.spacing(4),
  },
}));

const { exam } = RouteKey.child;

const { coordinatorExamRegistrations, coordinatorViewSummary } = RouteKey.exam.child;

interface ReceiptState {
  selectedPaymentMode: ExamPaymentModeKey;
}

const CoordinatorPaymentReceipt = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { classes } = useStyles();
  const { uuid: applicationUuid } = useParams<any>();
  const paymentMode = (history.location.state as ReceiptState).selectedPaymentMode;
  const { data: receiptData } = useGetGroupExamRegistrationReceiptDetails({
    uuid: applicationUuid,
  });

// wogaa tracking for coordinator to end exam registration //
  const { transactionEnd } = useWOGAA('myexamsseab-6454');
  transactionEnd(applicationUuid);

  const paymentDate = receiptData?.paymentDateTime
    ? stringToLongDateAndShortTime(receiptData.paymentDateTime)
    : '';

  return (
    <Box>
      <TitleHeader
        state="success"
        title={
          paymentMode === ExamPaymentModeKey.coordinatorPayOption ||
            paymentMode === ExamPaymentModeKey.noPaymentModeSelected
            ? t('exam->>ExamReceipt.RegisteredExam')
            : t('exam->>ExamReceipt.SubmittedExam')
        }
        largeContentContainer
      />
      <ContentTemplate>
        <SectionHeader
          title={t('exam->>ExamReceipt.PaymentSummary')}
        >
          <Link
              className={classes.viewSummaryLink}
              id="link-coordinatorViewFullSummary"
              onClick={() =>
                  history.push(
                      `/${exam}/${coordinatorExamRegistrations.route}/${applicationUuid}/${coordinatorViewSummary.route}`
                  )
              }
          >
            {t('exam->>ExamReceipt.ViewFullSummary')}
          </Link>
        </SectionHeader>
        {receiptData && (
          <Box>
            {paymentMode === ExamPaymentModeKey.candidatePayOption && (
              <Typography className={classes.paymentLinkMessage} variant="body1">
                {t('exam->>ExamReceipt.PaymentLinkMessage')}
              </Typography>
            )}
            <KeyValue
              keyText={t('exam->>RegistrationSummary.ApplicationId')}
              capitalize={false}
              valueText={receiptData.applicationId}
            />
            <KeyValue
              keyText={t('exam->>RegistrationSummary.ApplicationDateTime')}
              capitalize={false}
              valueText={paymentDate}
            />
          </Box>
        )}

        <Button
          id="button-groupExamReceipt-goToRegisteredExams"
          // className={classes.button}
          onClick={() => history.push(`/${exam}/${coordinatorExamRegistrations.route}`)}
        >
          {t('exam->>ExamReceipt.ViewRegisteredExam')}
        </Button>
      </ContentTemplate>
    </Box>
  );
};

export default CoordinatorPaymentReceipt;
